import {
  AfterViewInit,
  Component,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { CommonModule, DatePipe } from '@angular/common';

import * as Highcharts from 'highcharts';
import { environment } from '../../../environments/environment';

import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
} from '@angular/forms';
import { HelperService } from '../../services/helper-service';
import { Questions } from '../../models/questions';
import { MemberService } from '../member-service/MemberService ';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { ToastService } from '../../services/toast.service';
import {
  MemberTranscriptApiService,
  MemberTranscriptResponse,
} from '../member-service/member-transcript-api.service';

export type MemberTranscriptDetails = MemberTranscriptResponse | null;

@Component({
  selector: 'app-member-quetions',
  templateUrl: './member-quetions.component.html',
  standalone: true,
  imports: [CommonModule, MatListModule, FormsModule, MatExpansionModule],
  styleUrls: ['./member-quetions.component.css'],
})
export class MemberQuetionsComponent {
  memberTranscript: MemberTranscriptDetails = null;
  memberTranscriptEnabled = false;
  neoTranscriptLoading = false;
  neoTranscriptError: string | null = null;
  statusUpdateLoading = false;
  archiveLoading = false;
  showDeleteConfirm = false;
  showArchiveConfirm = false;
  transcriptFilter = 'all';
  expandedConversations: Set<number> = new Set();

  get filteredConversations(): Array<{ conv: any; originalIndex: number }> {
    const convs = this.memberTranscript?.neoConversations || [];
    return convs
      .map((conv: any, originalIndex: number) => ({ conv, originalIndex }))
      .filter(({ conv }) => {
        if (this.transcriptFilter === 'complete') return conv.onboardingStatus?.toLowerCase() === 'complete';
        if (this.transcriptFilter === 'incomplete') return conv.onboardingStatus?.toLowerCase() !== 'complete';
        return true;
      });
  }

  get completeCount(): number {
    return (this.memberTranscript?.neoConversations || [])
      .filter((c: any) => c.onboardingStatus?.toLowerCase() === 'complete').length;
  }

  get incompleteCount(): number {
    return (this.memberTranscript?.neoConversations || [])
      .filter((c: any) => c.onboardingStatus?.toLowerCase() !== 'complete').length;
  }

  toggleConversationExpand(index: number): void {
    if (this.expandedConversations.has(index)) {
      this.expandedConversations.delete(index);
    } else {
      this.expandedConversations.add(index);
    }
  }

  subTab: any = 'Medication';
  pdfSrc: string;
  activeTab: any;
  memberList: any = [];
  tZone: any;
  breakFastFood: any = [];
  snack1Food: any = [];
  lunchFood: any = [];
  snack2Food: any = [];
  dinnerFood: any = [];
  snack3Food: any = [];
  isImage: boolean;
  postData: any = [];
  postHealthAndMedQuestions: any = [];
  filtered: any;
  getTodaysDate: any;
  getDateRange: any = [];
  getTomorrowDate: any;
  PersonalityStressQuestion: any;
  PersonalityAnxietyQuestion: any;
  PersonalityEnneagramQuestion: any;
  DietaryRadioQuestion: any;
  DietaryDropDownQuestions: any;
  ingredient!: any;
  someval: any;
  fitnessQuestionsData: any;
  model: any = {};
  fetchMemberId: any;
  member: { memberId?: string } | null = null;
  savePersonalityBtn: boolean = false;
  pantryInfo: string;
  memberId: any;
  exerciseInfo: string;
  meetingsData: any;
  saveData: Questions[];
  mealNumbers: number;
  selectedRadio: any = { _id: null };
  selectedIndex: any = [];
  documents: any[] = [];
  firstPage: number = 0;
  totalRecords: number = 0;
  notAnswered: boolean = false;
  dateObjects: any;
  allDatesInRange: any;
  allDatesInRangeBMI: any;
  secondDate: any;
  secondDateBMI: any;
  todayMeetings: any[] = [];
  upcomingMeetings: any[] = [];
  firstDate: any;
  firstDateBMI: any;
  rangeDates: Date[] | undefined;

  PersonalityQuestionPost: any = [];
  DietaryQuestionPost: any = [];
  FitnessQuestionDataPost: any = [];
  LifestyleQuestionDataPost: any = [];
  HealthAndMedicationQuestionDataPost: any = [];
  DietaryQuestionDataPost: any = [];
  selectedOptions: any = {};

  PersonalityTab: any;
  commonQuestions: any = [];
  FitnessTab: any;
  LifestyleTab: any;
  LifestyleTabTextQuestions: any;
  notAnsweredQuestions: string[] = [];
  notAnsweredQuestionsStress: string[] = [];
  notAnsweredQuestionsAnxiety: string[] = [];
  LifestyleTabTimeQuestions: any;
  HealthAndMedicationTab: any;
  HealthAndMedicationListFields: any;
  HealthAndMedicationTextField: any;
  HealthAndMedicationMultiSelect: any;
  HealthAndMedicationPlainText: any;
  HealthAndMedicationMultiSelectWithKeys: any;
  DietaryMealsTable: any;
  DietaryTab: any;
  selectedAnswers: any = [];
  medications: any[] = [];
  supplements: any[] = [];
  loopcommon: any;
  healthMedFieldQ2: string;
  isSelectedAnswerBool: boolean = false;
  isSelectedDietaryAnswerBool: boolean = false;
  selectManual: any = [];
  foods2: any = [];
  isSelectAnswered: boolean = false;
  checkQuestionsIdIsThereOrNot: any = [];
  generateChartId: any = 'MyChart';
  currentImageIndex = 0;
  LifestyleTabDropDownQuestions: any;
  isFitnessAnswered: boolean = false;
  autofillLoading: boolean = false;
  private autofillDone: boolean = false;
  isPersonlaityAnswered: boolean = false;
  isLifestyleAnswered: boolean = false;
  fastingData: any = [];
  DietaryMealTable: any;
  selectedConditions: any = {};
  defaultDate: any;
  supplementsData: string[] = [''];
  formattedQualifications: string = '';
  selectedWakeUpTime: string = '';
  medicationsId: string;
  selectedBedTime: string = '';
  gulcoseData: any = [];
  gulcosePost: any;
  gulcoseFasting: any;
  options: any;
  postMeal: any = [];
  bmiValues: any = [];
  fasting: any = [];
  bmiReadings: any;
  bmiOptions: any;
  postDate: any = [];
  fastingDate: any = [];
  totalPostGulcose: any = 0;
  totalFasting: any = 0;
  weekStart: string;
  weekEnd: string;
  averagePostMeal: any = 0;
  averageFasting: any = 0;
  allFoodLog: any = [];
  form: FormGroup;
  allTabsIndices: number[];
  mealPlan: any = [];
  mealPlanTotalRecords: any = 0;
  visible: boolean = false;
  mealPlanHistory: any = [];
  maxDate = new Date();
  maxDateBMI = new Date();
  planFilter: any = '0';
  mealFasting: any = [];
  bmiWeightType: any = 1;
  weightByKg: any = [];
  kgWeight: any = [];
  weightByPound: any = [];
  BMIVals: any = [];
  Highcharts: typeof Highcharts = Highcharts; // required
  chartConstructor: string = 'chart'; // optional string, defaults to 'chart'
  chartOptions: Highcharts.Options = {}; // required
  chartOptionsGlucose: Highcharts.Options = {}; // required
  selectedMedications: any = '';
  selectedSupplements: any = '';
  selectedOptionsForDietary: any = {};
  familyHistoryData: any;
  optionsForEnegram: any = [];
  selectedFile: File;
  selectedPrescriptionFile: File;
  isSelectedFile: boolean = false;
  isReportUploadDisabled = false;
  isPrescriptionUploadDisabled = false;

  selectedFileName: string = '';
  fileType: string = '';

  selectedPrescriptionName: string = '';

  onboardingQuestions: any[] = [
    { questionId: "1", questionType: "wish", question: "What brought you here?", questionOptions: ["Reduce my medications or insulin (reduce_medications)", "Lose weight in a way that lasts (lose_weight)", "Make the most of my GLP-1 journey (glp1_journey)", "Get ahead of my health before it gets worse (preventive_health)"] },
    { questionId: "2", questionType: "wish", question: "Are you currently working with any of these?", questionOptions: ["Metformin (metformin)", "Insulin (insulin)", "GLP-1 (glp1)", "Other meds (other_meds)", "None yet (none_yet)", "Not sure (not_sure)"] },
    { questionId: "3", questionType: "wish", question: "How long have you been managing this?", questionOptions: ["Just found out (just_found_out)", "Under a year (under_a_year)", "1–5 years (1_to_5_years)", "5+ years (5_plus_years)"] },
    { questionId: "4", questionType: "wish", question: "What are you hoping life feels more like again?", questionOptions: ["Waking up with energy again (waking_energy)", "Feeling strong instead of drained (feeling_strong)", "Moving without feeling limited (move_freely)", "Sleep that actually rests me (restful_sleep)", "Feeling comfortable in my own body (comfortable_body)", "Trusting my body again (trust_body)", "Feeling like myself again (myself_again)", "Eating without it taking over my head (eating_peace)", "Feeling at peace with food (food_peace)", "Enjoying life without guilt (no_guilt)", "In charge of my day instead of chased by it (in_charge)", "A clearer head, less weight in my mind (clearer_head)", "Stopping the cycle for good (stop_cycle)", "Not being scared of my next checkup (no_checkup_fear)", "Being here for the long version of my life (long_version)", "Being more present with people I love (more_present)"] },
    { questionId: "5", questionType: "wish", question: "And what feels hardest right now?", questionOptions: ["Staying consistent (staying_consistent)", "Losing momentum after progress (losing_momentum)", "Starting over again and again (starting_over)", "Stress taking over (stress)", "Eating when I'm not really hungry (emotional_eating)", "Cravings I can't seem to outlast (cravings)", "Sleep that's never quite enough (poor_sleep)", "Days when I just can't get started (low_motivation)", "Having no time for myself (no_time)", "Feeling overwhelmed (overwhelmed)", "Not knowing what actually works (diet_confusion)", "Feeling stuck in old patterns (stuck_patterns)", "Feeling alone in this (feeling_alone)", "Hiding it from people around me (hiding_it)", "The guilt after a slip (guilt_slip)", "Feeling disconnected from my body (disconnected_body)", "Feeling betrayed by my own body (betrayed_body)"] },
    { questionId: "6", questionType: "safety", question: "A few things I need to know before we go further - so we can make sure HEALD is the right fit for what you need. Does any of this apply to you right now?", questionOptions: ["I am pregnant, or planning to be in the next 6 months (pregnant)", "I have Type 1 diabetes, or a rare form (type1)", "I have a history of stroke, heart issues, seizures, or kidney failure (history)", "I've experienced major depression or thoughts of harming myself (depression)", "I'd like to talk to someone before answering this (talk)", "None of these apply to me (none)"] },
    { questionId: "7", questionType: "safety", question: "When were you diagnosed?", questionOptions: ["Just recently (in the last 6 months) (recent)", "Within the past year or two (year)", "Several years ago (several)", "I've been managing this for a long time (longtime)", "I'd rather not specify (prefer_not)"] },
    { questionId: "8", questionType: "safety", question: "One quick safety check. Have you been in a hospital or ER for anything diabetes-related in the last 6 months?", questionOptions: ["Yes (yes)", "No (no)", "I'd like to explain (explain)"] },
    { questionId: "9", questionType: "safety", question: "Have you ever been hospitalized for blood sugar going too high or too low?", questionOptions: ["Yes - for blood sugar going too high (DKA or severe hyperglycemia) (high)", "Yes - for blood sugar going too low (low)", "Yes - both have happened (both)", "No, never (never)", "I'm not sure (not_sure)"] },
    { questionId: "10", questionType: "safety", question: "Do you have glucagon at home in case of a serious low?", questionOptions: ["Yes, I have it and know how to use it (yes_know)", "Yes, I have it but I'm not 100% sure how to use it (yes_unsure)", "No, but I've heard of it (no_heard)", "No, and I don't know what that is (no_unknown)"] },
    { questionId: "11", questionType: "clinical", question: "Do you currently check your sugar with a finger-stick glucometer?", questionOptions: ["Yes, regularly (yes_regularly)", "Sometimes (sometimes)", "Rarely (rarely)", "No - I have a CGM (no_cgm)", "No - I don't check (no_dont)"] },
    { questionId: "12", questionType: "clinical", question: "Have you ever felt a 'crash' - sweating, shaky, suddenly hungry, confused?", questionOptions: ["Yes, fairly often (fairly_often)", "Yes, occasionally (occasionally)", "Rarely (rarely)", "I've never felt that (never)", "Not sure (not_sure)"] },
    { questionId: "13", questionType: "clinical", question: "When that happened, did you handle it on your own - or did someone need to help you?", questionOptions: ["I handled it myself (myself)", "Someone had to help me (helped)", "It got serious enough that I needed medical attention (medical)"] },
    { questionId: "14", questionType: "clinical", question: "A quick check on anything else your body is navigating.", questionOptions: ["Hypertension (hypertension)", "High cholesterol (high_cholesterol)", "Heart disease (heart_disease)", "Fatty liver (fatty_liver)", "Thyroid (thyroid)", "PCOS (pcos)", "Diabetic eye disease (diabetic_eye)", "Diabetic kidney disease (diabetic_kidney)", "Diabetic foot issues (diabetic_foot)", "Neuropathy (neuropathy)", "Sleep apnea (sleep_apnea)", "Kidney disease (kidney_disease)", "Cancer (current or past) (cancer)", "Seizures (seizures)", "Migraines/headaches (migraines)", "Fainting episodes (fainting)", "Depression (depression)", "Anxiety (anxiety)", "Something else - let me describe (other)", "None of these (none)"] },
    { questionId: "15", questionType: "clinical", question: "Have you noticed any of these in your feet?", questionOptions: ["Numbness or tingling (numbness)", "Burning or shooting pain (burning)", "Cuts or sores that take a long time to heal (slow_healing)", "Changes in skin color or temperature (color_changes)", "Loss of feeling in some areas (loss_feeling)", "None of these (none)"] },
    { questionId: "16", questionType: "clinical", question: "Any recent changes in your vision?", questionOptions: ["Yes - blurry vision or trouble focusing (blurry)", "Yes - floaters, dark spots, or flashes (floaters)", "Yes - I've been told I have diabetic eye changes (diabetic_eye)", "No changes (no_changes)", "I haven't had an eye exam in over a year (no_exam)"] },
    { questionId: "17", questionType: "clinical", question: "Has anyone told you your kidneys are stressed or that you have early kidney disease?", questionOptions: ["Yes - I've been told about kidney concerns (yes_told)", "Yes - I take a medication for it (ACE inhibitor, SGLT2) (yes_meds)", "No (no)", "I don't know (dont_know)"] },
    { questionId: "18", questionType: "clinical", question: "In the last two weeks, how often have you felt down, depressed, or hopeless - or little interest or pleasure in doing things you usually enjoy?", questionOptions: ["Not at all (not_at_all)", "Several days (several_days)", "More than half the days (more_than_half)", "Nearly every day (nearly_every_day)"] },
    { questionId: "19", questionType: "clinical", question: "A quick sleep question. Pick anything that's true for you.", questionOptions: ["I snore loudly (loud enough to be heard through a door) (snore)", "I often feel tired or sleepy during the day, even after a full night (tired_day)", "Someone has noticed I stop breathing during sleep (stop_breathing)", "I have high blood pressure (high_bp)", "None of these (none)"] },
    { questionId: "20", questionType: "clinical", question: "When you get sick - flu, stomach bug, something that knocks you out for a few days - do you know how that affects your blood sugar and meds?", questionOptions: ["Yes, I have a plan for sick days (yes_plan)", "Sort of - I've heard about it (sort_of)", "No, this is new to me (no_new)", "I'm not on medications, so I haven't worried about it (no_meds)"] },
    { questionId: "21", questionType: "clinical", question: "Do you drive regularly?", questionOptions: ["Yes, I drive every day (every_day)", "Yes, sometimes (sometimes)", "Rarely (rarely)", "No, I don't drive (no)"] },
    { questionId: "22", questionType: "clinical", question: "Any food allergies I should know about?", questionOptions: ["Peanuts or tree nuts (nuts)", "Shellfish (shellfish)", "Dairy (dairy)", "Gluten / wheat (gluten)", "Eggs (eggs)", "Soy (soy)", "Other - let me list them (other)", "Something more serious - let's talk about it on the call (serious)", "No known food allergies (none)"] },
    { questionId: "23", questionType: "clinical", question: "Any medications that have caused you a serious reaction in the past?", questionOptions: ["Yes - let me list them (yes)", "No known medication allergies (no)", "Not sure (not_sure)"] },
    { questionId: "24", questionType: "clinical", question: "Any past injuries that still affect how you move?", questionOptions: ["Back or neck (back_neck)", "Knee (knee)", "Hip (hip)", "Shoulder (shoulder)", "Ankle or foot (ankle_foot)", "Wrist or elbow (wrist_elbow)", "Something else - let me describe (other)", "Nothing currently affecting me (none)"] },
    { questionId: "25", questionType: "clinical", question: "Does any of this run in your family?", questionOptions: ["Type 2 diabetes (t2d)", "Heart attack, stroke, or heart disease (heart)", "High cholesterol (cholesterol)", "High blood pressure (bp)", "Cancer (cancer)", "Depression or anxiety (mental)", "Obesity (obesity)", "Honestly not sure - I don't know my family history well (not_sure)", "None of these run in my family (none)"] },
    { questionId: "26", questionType: "clinical", question: "One quick thing about your eating rhythm. Between meals or snacks, what's the longest gap that feels normal for you in a typical day?", questionOptions: ["Less than 2 hours - I eat often (less_2)", "2 to 4 hours (two_four)", "4 to 6 hours (four_six)", "6+ hours - I can go a long time (six_plus)", "Varies a lot (varies)"] },
    { questionId: "27", questionType: "clinical", question: "When you reach for a snack - what do you actually reach for?", questionOptions: ["Nuts, seeds, or jerky (nuts)", "Fresh fruit (fruit)", "Yogurt or cheese (yogurt)", "Crackers, chips, or pretzels (crackers)", "Cookies, candy, or chocolate (sweets)", "Soda, juice, or sweetened coffee/tea (drinks)", "Whatever's in the house - varies a lot (varies)", "I don't really snack (none)"] },
    { questionId: "28", questionType: "clinical", question: "What does your work life look like?", questionOptions: ["Desk-based, regular hours (9-to-5ish) (desk_regular)", "Desk-based, long or unpredictable hours (desk_long)", "On my feet most of the day (on_feet)", "Shift work or night shifts (shift)", "Caregiver / at home most of the day (caregiver)", "Retired or not currently working (retired)", "Mix of the above / hard to categorize (mix)"] },
    { questionId: "29", questionType: "clinical", question: "During work hours, can you usually pause to eat?", questionOptions: ["Yes, I take real meal breaks (yes_breaks)", "I grab something quickly between things (quickly)", "Sometimes - depends on the day (sometimes)", "Rarely - I eat whenever I can (rarely)", "My work doesn't really have 'breaks' (no_breaks)"] },
    { questionId: "30", questionType: "clinical", question: "And on alcohol -", questionOptions: ["I don't drink (none)", "Rarely (a few times a year) (rarely)", "Occasionally (a drink or two a week) (occasionally)", "Regularly (most days) (regularly)", "Several drinks most days (several)", "I'd rather discuss this with {advocate} (sarah)"] },
    { questionId: "31", questionType: "clinical", question: "And smoking, vaping, or any tobacco use -", questionOptions: ["None of these (none)", "I quit (a while ago) (quit)", "I'm trying to quit (trying)", "I smoke occasionally (occasionally)", "I smoke daily (daily)"] },
    { questionId: "32", questionType: "clinical", question: "Anything making movement harder for you right now?", questionOptions: ["Yes - something's limiting me (yes)", "Some days are harder than others (some_days)", "No, I move pretty freely (no)"] },
    { questionId: "33", questionType: "clinical", question: "Any chronic pain or discomfort you're managing?", questionOptions: ["Joint pain (knees, hips, hands) (joint)", "Back pain (back)", "Nerve pain or tingling (hands, feet) (nerve)", "Headaches or migraines (headaches)", "Stomach or digestive discomfort (stomach)", "Something else (other)", "Nothing significant right now (none)"] },
    { questionId: "34", questionType: "clinical", question: "What kind of movement do you actually enjoy?", questionOptions: ["Walking (walking)", "Strength training / weights (weights)", "Yoga / Pilates / stretching (yoga)", "Dance / cardio classes (dance)", "Hiking or being outside (hiking)", "Swimming (swimming)", "Cycling (cycling)", "Sports (tennis, pickleball, etc.) (sports)", "Honestly - nothing right now (nothing)", "Something else (other)"] },
    { questionId: "35", questionType: "clinical", question: "When do you feel best moving?", questionOptions: ["Morning (morning)", "Lunchtime (lunch)", "Afternoon (afternoon)", "Evening (evening)", "Late night (late_night)", "Depends on the day (depends)"] },
    { questionId: "36", questionType: "clinical", question: "Anything you do to wind down or settle your nervous system?", questionOptions: ["Meditation or breathing practices (meditation)", "Yoga (yoga)", "Prayer or quiet time (prayer)", "Reading, music, or being alone (reading)", "Walking (walking)", "I haven't found anything that works yet (nothing_found)", "Nothing - and I'd like to try something (nothing_try)"] },
    { questionId: "37", questionType: "documents", selectionType: "single_select", question: "Share your most recent blood report.", questionOptions: ["Take a photo", "Pick a file", "I'll do this later", "I don't have a recent one"] },
    { questionId: "39", questionType: "documents", selectionType: "text", question: "Blood report values (as read from your uploaded report)", questionOptions: [] },
    { questionId: "38", questionType: "documents", selectionType: "single_select", question: "If you wear a CGM (Dexcom, Libre, or any other) you can pull a recent report from the app.", questionOptions: ["Upload CGM report", "Skip - kit's coming"] },
  ];

  onboardingLoading: boolean = false;
  onboardingError: string | null = null;
  apiAnswerMap: Map<string, string[]> = new Map();
  onboardingSelectedAnswers: Map<string, string[]> = new Map();
  onboardingUpdateLoading: boolean = false;
  onboardingUpdateError: string | null = null;
  onboardingUpdateSuccess: boolean = false;
  onboardingFilter: 'all' | 'answered' | 'unanswered' = 'all';
  onboardingCategory: 'wish' | 'safety' | 'clinical' | 'documents' = 'wish';
  memberPlanStatus: string = '';
  private readonly frozenOnboardingCategories = new Set(['safety', 'clinical', 'documents']);

  get isMemberNonPaid(): boolean {
    return this.memberPlanStatus.replace(/\s+/g, '').toLowerCase() === 'non-paid';
  }

  isCategoryFrozen(questionType: string): boolean {
    return this.isMemberNonPaid && this.frozenOnboardingCategories.has(questionType);
  }

  private getQuestionType(questionId: string): string {
    const q = this.onboardingQuestions.find((item: any) => String(item.questionId) === String(questionId));
    return q?.questionType ?? '';
  }

  loadMemberPlanStatus(): void {
    const memberId = this.memberId || this.route.snapshot.queryParamMap.get('id') || '';
    if (!memberId) return;
    this.MembersService.getMemberPlanStatus(memberId).subscribe({
      next: (res: any) => {
        this.memberPlanStatus = res?.planStatus ?? '';
        this.cdr.markForCheck();
      },
      error: () => {
        this.memberPlanStatus = '';
      },
    });
  }

  get displayedOnboardingGroups(): Array<{type: string; label: string; questions: any[]}> {
    const categoryFiltered = this.groupedOnboardingQuestions.filter(g => g.type === this.onboardingCategory);
    return categoryFiltered
      .map(group => ({
        ...group,
        questions: group.questions
          .map((q, i) => ({...q, _displayIndex: i + 1}))
          .filter((q: any) => {
            if (this.onboardingFilter === 'all') return true;
            const qId = String(q.questionId);
            const hasSelection = (this.onboardingSelectedAnswers.get(qId) ?? []).length > 0;
            const hasFreeText = (this.onboardingFreeTextValues[qId] ?? '').trim().length > 0;
            const answered = hasSelection || hasFreeText;
            return this.onboardingFilter === 'answered' ? answered : !answered;
          })
      }))
      .filter(g => g.questions.length > 0);
  }

  private readonly textTriggerOptions: { [questionId: string]: string[] } = {
    '8':  ["I'd like to explain (explain)"],
    '14': ['Something else - let me describe (other)'],
    '22': ['Other - let me list them (other)'],
    '23': ['Yes - let me list them (yes)'],
    '24': ['Something else - let me describe (other)'],
    '32': ["Yes - something's limiting me (yes)"],
    '33': ['Something else (other)'],
    '34': ['Something else (other)'],
    '36': ["Nothing - and I'd like to try something (nothing_try)"],
  };
  onboardingFreeTextValues: { [questionId: string]: string } = {};
  private apiFreeTextMap: { [questionId: string]: string } = {};

  private readonly singleSelectQuestionIds = new Set([
    '1','3','7','8','9','10','11','12','13','16','17','18','20','21','23','26','28','29','30','31','32','35','37','38'
  ]);

  private readonly alwaysFreeTextQuestionIds = new Set(['39']);

  readonly groupedOnboardingQuestions: Array<{type: string; label: string; questions: any[]}> = (() => {
    const groups: Array<{type: string; label: string; questions: any[]}> = [
      { type: 'wish', label: 'Wish', questions: [] },
      { type: 'safety', label: 'Safety', questions: [] },
      { type: 'clinical', label: 'Clinical', questions: [] },
      { type: 'documents', label: 'Documents', questions: [] },
    ];
    (this as any).onboardingQuestions.forEach((q: any) => {
      const g = groups.find(gr => gr.type === q.questionType);
      if (g) g.questions.push(q);
    });
    return groups.filter(g => g.questions.length > 0);
  })();

  trackByGroupType(_: number, group: {type: string}): string { return group.type; }
  trackByQuestionId(_: number, q: {questionId: any}): any { return q.questionId; }
  trackByOption(_: number, opt: string): string { return opt; }

  getOptionLabel(option: string): string {
    return option.replace(/\s*\([^)]+\)\s*$/, '').trim();
  }

  shouldShowFreeText(questionId: string): boolean {
    if (this.isCategoryFrozen(this.getQuestionType(String(questionId)))) return false;
    if (this.alwaysFreeTextQuestionIds.has(String(questionId))) return true;
    const triggers = this.textTriggerOptions[String(questionId)];
    if (!triggers?.length) return false;
    const current = this.onboardingSelectedAnswers.get(String(questionId)) || [];
    return triggers.some(trigger => {
      const triggerLabel = this.getOptionLabel(trigger).toLowerCase().trim();
      return current.some(c => c.toLowerCase().trim() === triggerLabel);
    });
  }

  isTextTriggerOption(questionId: string, option: string): boolean {
    return (this.textTriggerOptions[String(questionId)] || []).includes(option);
  }

  private parseAnswers(questionId: string, answerString: string): string[] {
    const q = this.onboardingQuestions.find((item: any) => String(item.questionId) === String(questionId));
    const knownOptions: string[] = (q?.questionOptions ?? [])
      .map((o: string) => this.getOptionLabel(o))
      .filter(Boolean);

    if (!knownOptions.length) {
      return answerString.split(',').map((a: string) => a.trim()).filter(Boolean);
    }

    // Sort longest-first so greedy scan picks "Reading, music, or being alone" before "Reading"
    const sorted = [...knownOptions].sort((a, b) => b.length - a.length);
    const result: string[] = [];
    let remaining = answerString.trim();

    while (remaining.length > 0) {
      let matched = false;
      for (const opt of sorted) {
        if (remaining.toLowerCase().startsWith(opt.toLowerCase())) {
          result.push(opt);
          remaining = remaining.slice(opt.length).replace(/^[,\s]+/, '');
          matched = true;
          break;
        }
      }
      if (!matched) {
        const nextComma = remaining.indexOf(',');
        if (nextComma === -1) break;
        remaining = remaining.slice(nextComma + 1).trimStart();
      }
    }

    return result;
  }

  private formatMultilineAnswer(text: string): string {
    return text.trim().replace(/;\s+/g, ';\n');
  }

  private extractFreeText(questionId: string, answerString: string): string {
    if (!this.textTriggerOptions[String(questionId)]?.length) return '';
    const q = this.onboardingQuestions.find((item: any) => String(item.questionId) === String(questionId));
    const knownOptions: string[] = (q?.questionOptions ?? [])
      .map((o: string) => this.getOptionLabel(o))
      .filter(Boolean);
    if (!knownOptions.length) return '';
    const sorted = [...knownOptions].sort((a, b) => b.length - a.length);
    let remaining = answerString.trim();
    while (remaining.length > 0) {
      let matched = false;
      for (const opt of sorted) {
        if (remaining.toLowerCase().startsWith(opt.toLowerCase())) {
          remaining = remaining.slice(opt.length).replace(/^[,\s]+/, '');
          matched = true;
          break;
        }
      }
      if (!matched) {
        // Skip inline option codes like (nothing_try)
        const codeMatch = remaining.match(/^\([^)]+\)/);
        if (codeMatch) {
          remaining = remaining.slice(codeMatch[0].length).replace(/^[,\s]+/, '');
          continue;
        }
        // Everything left is free text — return as-is, preserving commas and symbols
        return remaining;
      }
    }
    return '';
  }

  isAnswered(questionId: string, option: string): boolean {
    const answers = this.apiAnswerMap.get(String(questionId));
    if (!answers?.length) return false;
    const label = this.getOptionLabel(option).toLowerCase().trim();
    return answers.some(a => a.toLowerCase().trim() === label);
  }

  isOnboardingSelected(questionId: string, option: string): boolean {
    if (this.isCategoryFrozen(this.getQuestionType(String(questionId)))) return false;
    const current = this.onboardingSelectedAnswers.get(String(questionId));
    if (!current?.length) return false;
    const label = this.getOptionLabel(option).toLowerCase().trim();
    return current.some(a => a.toLowerCase().trim() === label);
  }

  toggleOption(questionId: string, option: string): void {
    const qId = String(questionId);
    if (this.isCategoryFrozen(this.getQuestionType(qId))) return;
    const label = this.getOptionLabel(option).trim();
    const current = this.onboardingSelectedAnswers.get(qId) ?? [];
    const idx = current.findIndex(a => a.toLowerCase() === label.toLowerCase());
    if (this.singleSelectQuestionIds.has(qId)) {
      // Single-select: clicking the already-selected pill deselects it, otherwise replace
      this.onboardingSelectedAnswers.set(qId, idx >= 0 ? [] : [label]);
    } else {
      if (idx >= 0) {
        this.onboardingSelectedAnswers.set(qId, current.filter((_, i) => i !== idx));
      } else {
        this.onboardingSelectedAnswers.set(qId, [...current, label]);
      }
    }
    this.onboardingUpdateSuccess = false;
    this.cdr.markForCheck();
  }

  getEditedQuestions(): Array<{questionId: string; questionType: string; answer: string}> {
    const edited: Array<{questionId: string; questionType: string; answer: string}> = [];
    this.onboardingQuestions.forEach((q: any) => {
      const qId = String(q.questionId);
      const original = [...(this.apiAnswerMap.get(qId) ?? [])].sort().join(',');
      const current = [...(this.onboardingSelectedAnswers.get(qId) ?? [])].sort().join(',');
      const freeText = (this.onboardingFreeTextValues[qId] ?? '').trim();
      const showFreeText = this.shouldShowFreeText(qId);
      const hasFreeText = freeText.length > 0 && showFreeText;
      const freeTextChanged = showFreeText && freeText !== (this.apiFreeTextMap[qId] ?? '');
      const selectedLabels = this.onboardingSelectedAnswers.get(qId) ?? [];
      const answer = hasFreeText ? [...selectedLabels, freeText].join(', ') : selectedLabels.join(', ');
      if (original !== current || freeTextChanged) {
        edited.push({ questionId: qId, questionType: q.questionType ?? '', answer });
      }
    });
    return edited;
  }

  updateOnboardingAnswers(): void {
    if (this.isCategoryFrozen(this.onboardingCategory)) return;
    const memberId = this.memberId || this.route.snapshot.queryParamMap.get('id') || '';
    if (!memberId) return;
    const edited = this.getEditedQuestions();
    if (!edited.length) return;
    this.onboardingUpdateLoading = true;
    this.onboardingUpdateError = null;
    this.onboardingUpdateSuccess = false;
    this.MembersService.updateMemberOnboardingAnswers(memberId, edited).subscribe({
      next: () => {
        edited.forEach(e => {
          const answers = e.answer.split(',').map((a: string) => a.trim()).filter(Boolean);
          this.apiAnswerMap.set(e.questionId, answers);
        });
        this.onboardingUpdateLoading = false;
        this.onboardingUpdateSuccess = true;
        this.cdr.markForCheck();
      },
      error: (err: any) => {
        this.onboardingUpdateError = err?.error?.message ?? err?.message ?? 'Failed to update answers.';
        this.onboardingUpdateLoading = false;
        this.cdr.markForCheck();
      },
    });
  }

  loadOnboardingQuestions(): void {
    const memberId = this.memberId || this.route.snapshot.queryParamMap.get('id') || '';
    if (!memberId) return;
    this.onboardingLoading = true;
    this.onboardingError = null;
    this.apiAnswerMap.clear();
    this.onboardingSelectedAnswers.clear();
    this.onboardingUpdateSuccess = false;
    this.MembersService.getMemberOnboardingQuestions(memberId).subscribe({
      next: (res: any) => {
        const raw: any[] = Array.isArray(res)
          ? res
          : Array.isArray(res?.questions)
          ? res.questions
          : Array.isArray(res?.items)
          ? res.items
          : Array.isArray(res?.result)
          ? res.result
          : [];
        this.apiFreeTextMap = {};
        this.onboardingFreeTextValues = {};
        raw.forEach((q: any) => {
          if (q.questionId && q.answer) {
            const qId = String(q.questionId);
            if (this.alwaysFreeTextQuestionIds.has(qId)) {
              const formatted = this.formatMultilineAnswer(String(q.answer));
              this.apiAnswerMap.set(qId, []);
              this.onboardingSelectedAnswers.set(qId, []);
              this.apiFreeTextMap[qId] = formatted;
              this.onboardingFreeTextValues[qId] = formatted;
              return;
            }
            const answers = this.parseAnswers(qId, String(q.answer));
            this.apiAnswerMap.set(qId, answers);
            this.onboardingSelectedAnswers.set(qId, [...answers]);
            const freeText = this.extractFreeText(qId, String(q.answer));
            if (freeText) {
              this.apiFreeTextMap[qId] = freeText;
              this.onboardingFreeTextValues[qId] = freeText;
            }
          }
        });
        this.onboardingLoading = false;
        this.cdr.markForCheck();
      },
      error: (err: any) => {
        this.onboardingError = err?.error?.message ?? err?.message ?? 'Failed to load onboarding answers.';
        this.onboardingLoading = false;
        this.cdr.markForCheck();
      },
    });
  }

  constructor(
    private toast: ToastService,
    private route: ActivatedRoute,
    private HelperService: HelperService,
    private MembersService: MemberService,
    private memberTranscriptApiService: MemberTranscriptApiService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.memberId =
      this.route.snapshot.queryParamMap.get('id') ||
      this.route.snapshot.paramMap.get('memberId') ||
      '';
    this.memberTranscript = null;

    this.defaultDate = new Date().toISOString().split('T')[0];

    for (let hour = 0; hour < 24; hour++) {
      const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
      const amPm = hour < 12 ? 'AM' : 'PM';
    }

    this.getMemberQuetions();
    this.resolveMemberForTranscript();
    this.loadMemberPlanStatus();
    //  this.fitnessQuestionsData = fitnessData

    this.getTodaysDate = new Date();
    this.getTomorrowDate = new Date(
      this.getTodaysDate.getTime() + 24 * 60 * 60 * 1000
    );
  }
  getMemberQuetions() {
    this.MembersService.GetMemberQuestionnaire(this.memberId).subscribe(
      (data) => {
        data = data.items;
        this.PersonalityTab = data.filter(
          (questions: any) => questions.questionCategory === 'Personality'
        );
        this.PersonalityStressQuestion = this.PersonalityTab.filter(
          (questions: any) => questions.questionSubCategory === 'StressTest'
        );
        this.PersonalityAnxietyQuestion = this.PersonalityTab.filter(
          (questions: any) => questions.questionSubCategory === 'AnxietyTest'
        );
        this.PersonalityEnneagramQuestion = this.PersonalityTab.filter(
          (questions: any) => questions.questionSubCategory === 'EnneagramTest'
        );
        this.DietaryRadioQuestion = data.filter(
          (questions: any) => questions.questionSubCategory === 'choice'
        );
        this.DietaryDropDownQuestions = data.filter(
          (questions: any) =>
            questions.questionSubCategory === 'multiSelectWithKeys' &&
            questions.questionSubCategory !== 'choice'
        );

        this.FitnessTab = data.filter(
          (questions: any) => questions.questionCategory === 'Fitness'
        );
        this.selectedAnswers = this.PersonalityTab.map(
          (questions: any) => questions.answer
        );
        this.LifestyleTab = data.filter(
          (questions: any) => questions.questionCategory === 'Lifestyle'
        );
        this.LifestyleTabTextQuestions = data.filter(
          (questions: any) =>
            questions.questionCategory === 'Lifestyle' &&
            questions.dataType !== 'time' &&
            questions.dataType !== 'multiSelectWithKeys'
        );
        this.LifestyleTabTimeQuestions = data.filter(
          (questions: any) =>
            questions.questionCategory === 'Lifestyle' &&
            questions.dataType == 'time'
        );
        this.LifestyleTabDropDownQuestions = data.filter(
          (questions: any) =>
            questions.questionCategory === 'Lifestyle' &&
            questions.dataType == 'multiSelectWithKeys'
        );
        this.HealthAndMedicationTab = data.filter(
          (questions: any) =>
            questions.questionCategory === 'HealthAndMedication'
        );
        this.HealthAndMedicationTextField = data.filter(
          (questions: any) =>
            questions.questionCategory === 'HealthAndMedication' &&
            questions.isListField == false
        );
        this.HealthAndMedicationListFields = data.filter(
          (questions: any) =>
            questions.questionCategory === 'HealthAndMedication' &&
            questions.dataType == 'multiText'
        );
        this.HealthAndMedicationMultiSelect = data.filter(
          (questions: any) =>
            questions.questionCategory === 'HealthAndMedication' &&
            questions.dataType == 'multiSelect'
        );
        this.HealthAndMedicationPlainText = data.filter(
          (questions: any) =>
            questions.questionCategory === 'HealthAndMedication' &&
            questions.dataType == 'plainText'
        );
        this.HealthAndMedicationMultiSelectWithKeys = data.filter(
          (questions: any) =>
            questions.questionCategory === 'HealthAndMedication' &&
            questions.dataType == 'MultiSelectWithKeys'
        );
        this.DietaryMealsTable = data.filter(
          (questions: any) =>
            questions.questionCategory === 'Dietary' &&
            questions.questionSubCategory == 'MealsGrid'
        );
        const formGroups: any = {};
        this.HealthAndMedicationMultiSelect.forEach((question: any) => {
          const optionsArray = question.options.map((option: any) =>
            this.createConditionItem(option)
          );
          formGroups[question.question.toLowerCase()] =
            this.fb.array(optionsArray);
        });
        this.form = this.fb.group(formGroups);
        this.mapAnswersToFormControls();
        const medicinesList = this.HealthAndMedicationListFields[0].answer;

        // medicaiton list
        this.medications = medicinesList;

        if (this.medications !== null) {
          this.selectedMedications = 'Yes';
        }
        const supplmentsList = this.HealthAndMedicationListFields[1].answer;
        // supplements list
        this.supplements = supplmentsList;
        if (this.supplements !== null) {
          this.selectedSupplements = 'Yes';
        }

        this.DietaryTab = data.filter(
          (questions: any) =>
            questions.questionCategory === 'Dietary' &&
            questions.questionSubCategory == 'plainText'
        );
        this.notAnsweredQuestions = this.PersonalityEnneagramQuestion.filter(
          (question: any) => question.answer === 'not answered'
        ).map((question: any) => question.id);
        this.notAnsweredQuestionsStress = this.PersonalityStressQuestion.filter(
          (question: any) => question.answer === 'not answered'
        ).map((question: any) => question.id);
        this.notAnsweredQuestionsAnxiety =
          this.PersonalityAnxietyQuestion.filter(
            (question: any) => question.answer === 'not answered'
          ).map((question: any) => question.id);
        for (let i = 0; i < this.PersonalityTab.length; i++) {
          this.selectedOptions[this.PersonalityTab[i].id] =
            this.PersonalityTab[i].answer;
        }
        // this.tryAutoFill();
      }
    );
  }
  removeMedication(index: number) {
    this.medications.splice(index, 1);
  }
  removeSupplement(index: number) {
    this.supplements.splice(index, 1);
  }
  addSupplements(): void {
    if (!this.supplements) {
      this.supplements = [];
    }
    this.supplements.push('');
    this.cdr.detectChanges();
  }
  logMedications() {
    // console.log('Updated Medications:', this.medications);
  }
  logSupplements() {
    // console.log('Updated Supplements:', this.supplements);
  }
  trackByFn(index: number, item: string): number {
    return index;
  }
  trackByFnSupplements(index: number, item: string): number {
    return index;
  }
  addMedications(id: any): void {
    if (!this.medications) {
      this.medications = [];
    }
    this.medications.push('');
    this.cdr.detectChanges();
    this.medicationsId = id;
  }
  ngAfterViewInit() {
    // this.createChart();
  }

  createConditionItem(option: string): FormControl {
    return this.fb.control(false);
  }
  mapAnswersToFormControls(): void {
    if (this.HealthAndMedicationMultiSelect) {
      this.HealthAndMedicationMultiSelect.forEach((question: any) => {
        const formArray = this.getFormArrayByName(
          question.question.toLowerCase()
        );
        if (formArray) {
          const selectedOptions = question.answer || [];
          selectedOptions.forEach((selectedOption: any) => {
            const index = question.options.indexOf(selectedOption);
            if (index !== -1) {
              const control = formArray.at(index) as FormControl;
              if (control) {
                control.setValue(true);
              }
            }
          });
        }
      });
    }
  }
  externalTooltipHandler() {
    return 'hello';
  }

  getFormArrayByName(name: string): FormArray {
    return this.form.get(name) as FormArray;
  }

  toggleSelection(formArrayName: string, index: number): void {
    const formArray = this.getFormArrayByName(formArrayName);
    const control = formArray.at(index) as FormControl;
    control.setValue(!control.value);
  }
  logSelections(): void {
    const selections: any = {};

    if (this.HealthAndMedicationMultiSelect) {
      this.HealthAndMedicationMultiSelect.forEach((question: any) => {
        const formArray = this.getFormArrayByName(
          question.question.toLowerCase()
        );

        if (formArray) {
          const selectedOptions = formArray.value
            .map((selected: any, index: any) =>
              selected ? question.options[index] : null
            )
            .filter(Boolean);

          selections[question.question] = selectedOptions;
        }
      });
    }

    // console.log('Selections:', selections);
  }

  getOption(answer: any, question: any) {
    this.isSelectedAnswerBool = true;

    if (answer === 'not answered') {
      this.notAnswered = true;
    } else {
      this.notAnswered = false;
    }

    this.PersonalityQuestionPost.push({
      questionId: question,
      memberId: this.memberId,
      answer: answer,
      loggedInUserId: this.memberId,
    });

    this.selectedOptions[question] = answer;
  }

  getOptionForDietary(answer: any, question: any) {
    this.isSelectedDietaryAnswerBool = true;
    this.DietaryQuestionPost.push({
      questionId: question,
      memberId: this.memberId,
      answer: answer,
      loggedInUserId: this.memberId,
    });
    this.selectedOptions[question] = answer;
  }

  getFitness(question: any, answer: any) {
    this.FitnessQuestionDataPost.push({
      questionId: question,
      memberId: this.memberId,
      answer: answer.target.value == 'on' ? '' : answer.target.value,
      loggedInUserId: this.memberId,
    });
  }
  saveFitnessQuestions() {
    this.isFitnessAnswered = true;
    this.MembersService.saveQuestionaire(
      this.FitnessQuestionDataPost
    ).subscribe((data) => {
      this.MembersService.GetMemberQuestionnaire(
        this.route.snapshot.queryParamMap.get('id')
      ).subscribe((data) => {
        this.FitnessTab = data.items.filter(
          (questions: any) => questions.questionCategory === 'Fitness'
        );
        let answeredQuestions = this.FitnessTab.map((items: any) => {
          return items.answer;
        });
        if (!answeredQuestions.includes(null)) {
          this.toast.successMessage('Fitness answeres saved successfully');
        } else {
          this.toast.errorMessage('Some questions are not answered');
        }
      });
    });
  }

  getLifestyleAnswers(question: any, answer: any) {
    var formattedTime;
    if (answer.target.type === 'time') {
      const selectedTime = answer.target.value;
      const timeParts = selectedTime.split(':');
      const selectedDate = new Date();
      selectedDate.setHours(parseInt(timeParts[0], 10));
      selectedDate.setMinutes(parseInt(timeParts[1], 10));
      formattedTime = this.datePipe.transform(selectedDate, 'hh:mm a');
    }
    const answerValue =
      answer.target.type === 'time' ? formattedTime : answer.target.value;
    this.LifestyleQuestionDataPost.push({
      questionId: question,
      memberId: this.memberId,
      answer: answerValue === 'on' ? '' : answerValue,
      loggedInUserId: this.memberId,
    });
  }

  saveLifestyleAnswers() {
    this.isLifestyleAnswered = true;
    this.MembersService.saveQuestionaire(
      this.LifestyleQuestionDataPost
    ).subscribe((data) => {
      this.MembersService.GetMemberQuestionnaire(
        this.route.snapshot.queryParamMap.get('id')
      ).subscribe((data) => {
        this.LifestyleTab = data.items.filter(
          (questions: any) => questions.questionCategory === 'Lifestyle'
        );
        let answeredQuestions = this.LifestyleTab.map((items: any) => {
          return items.answer;
        });
        if (!answeredQuestions.includes(null)) {
          this.toast.successMessage('Lifestyle answeres saved successfully');
          this.isLifestyleAnswered = false;
        } else {
          this.toast.successMessage('Lifestyle answeres saved successfully');
          // this.toastr.warning("Some questions are not answered");
        }
      });
    });
  }

  getQuestionIdBasedOnKey(key: string): string {
    const mapping: any = {
      'grand parents': '6572fb5758eaad264a416c6c',
      mother: '6572fb6358eaad264a416c6d',
      father: '6572fb7058eaad264a416c6e',
      siblings: '6572fb7b58eaad264a416c6f',
    };

    return mapping[key] || '';
  }

  getOptionBasedOnIndex(questionKey: string, index: number): string {
    const optionsMapping: any = {
      'grand parents': [
        'Diabetes',
        'Heart Disease',
        'Cholestrol',
        'High BP',
        'Depression Anxiety',
      ],
      mother: [
        'Diabetes',
        'Heart Disease',
        'Cholestrol',
        'High BP',
        'Depression Anxiety',
      ],
      father: [
        'Diabetes',
        'Heart Disease',
        'Cholestrol',
        'High BP',
        'Depression Anxiety',
      ],
      siblings: [
        'Diabetes',
        'Heart Disease',
        'Cholestrol',
        'High BP',
        'Depression Anxiety',
      ],
    };
    const options = optionsMapping[questionKey] || [];
    return options[index] || '';
  }

  getHealthAndMedicationAnswers(question: any, answer: any) {
    this.postHealthAndMedQuestions.push({
      questionId: question,
      memberId: this.memberId,
      answer: answer.target.value == 'on' ? '' : answer.target.value,
      loggedInUserId: this.memberId,
    });
    //console.log(this.postHealthAndMedQuestions)
  }
  saveHealthAndMedicationAnswers() {
    if (!this.selectedFile) {
    } else {
      this.isPrescriptionUploadDisabled = false;
      this.isReportUploadDisabled = false;
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result as string;
        const parts = base64String.split(',');

        if (parts.length === 2 && parts[1].startsWith('J')) {
          const trimmedBase64 = parts[1];
        } else {
          console.error('Invalid Base64 string format.');
        }
        const fileData = {
          uploadFileS: parts[1],
          type: this.fileType,
          addedBy: this.memberId,
          memberId: this.memberId,
          reportName: this.selectedFileName,
          prescriptionName: this.selectedPrescriptionName,
        };
        // console.log(fileData);
        this.MembersService.uploadFile(fileData).subscribe((data) => {
          this.toast.successMessage(this.fileType + ' uploaded successfully');
          this.MembersService.GetLabWork(
            this.route.snapshot.queryParamMap.get('id'),
            1
          ).subscribe((data) => {
            const documentsData = data['labWorkList'];
            this.documents = documentsData.sort((a: any, b: any) => {
              const dateA = new Date(a.createdDateTime);
              const dateB = new Date(b.createdDateTime);
              return dateB.getTime() - dateA.getTime();
            });
            this.totalRecords = data['totalCount'];
          });
        });
      };
      reader.readAsDataURL(
        this.selectedFile == null
          ? this.selectedPrescriptionFile
          : this.selectedFile
      );
    }

    // this.HealthAndMedicationQuestionDataPost.push({
    //   "questionId":"6513fe8fb26bb90cc03fbaa5",
    //   "memberId": this.members.id,
    //   "answer": this.medications,
    //   "medicines":[],
    //   "loggedInUserId":this.memberId.id
    // })

    const formData = this.form.value;
    // this.postData.push(this.postHealthAndMedQuestions);
    //console.log(this.postData);
    //console.log(this.postHealthAndMedQuestions);
    this.postData = Object.keys(formData).map((key) => {
      return {
        questionId: this.getQuestionIdBasedOnKey(key),
        memberId: this.memberId,
        answer: formData[key]
          .map((selected: any, index: any) =>
            selected ? this.getOptionBasedOnIndex(key, index) : null
          )
          .filter(Boolean),
        loggedInUserId: this.memberId.id,
      };
    });
    const medicationList = {
      questionId: '6513fe8fb26bb90cc03fbaa5',
      memberId: this.memberId,
      answer: this.medications == null ? [] : this.medications,
      loggedInUserId: this.memberId.id,
    };
    const supplementList = {
      questionId: '6513fe99b26bb90cc03fbaa6',
      memberId: this.memberId,
      answer: this.supplements == null ? [] : this.supplements,
      loggedInUserId: this.memberId.id,
    };
    this.postData = this.postData.concat(this.postHealthAndMedQuestions);

    this.postData.push(medicationList, supplementList);
    this.MembersService.saveQuestionaire(this.postData).subscribe((data) => {
      this.toast.successMessage(
        'Health & medication answeres saved successfully'
      );
    });
  }

  getDietary(question: any, answer: any, isRadio: any) {
    if (isRadio == 'radio') {
      this.DietaryQuestionDataPost.push({
        questionId: answer,
        memberId: this.memberId,
        answer: question,
        loggedInUserId: this.memberId,
      });
    } else {
      this.DietaryQuestionDataPost.push({
        questionId: question,
        memberId: this.memberId,
        answer: answer.target.value == 'on' ? '' : answer.target.value,
        loggedInUserId: this.memberId,
      });
    }
  }
  saveDietaryQuestions() {
    this.isFitnessAnswered = true;
    this.MembersService.saveQuestionaire(
      this.DietaryQuestionDataPost
    ).subscribe((data) => {
      this.MembersService.GetMemberQuestionnaire(
        this.route.snapshot.queryParamMap.get('id')
      ).subscribe((data) => {
        // this.DietaryTab = data.filter((questions:any) => questions.questionCategory === "Dietary");
        this.toast.successMessage('Dietary answeres saved successfully');
        let answeredQuestions = this.FitnessTab.map((items: any) => {
          return items.answer;
        });
      });
    });
  }

  isSelected(questionId: string, option: string): any {
    return this.selectedOptions[questionId] === option;
  }

  isSelectedDietary(questionId: string, option: string): any {
    return this.selectedOptionsForDietary[questionId] === option;
  }

  saveQuestion() {
    this.isSelectAnswered = true;
    this.savePersonalityBtn = true;
    this.MembersService.saveQuestionaire(
      this.PersonalityQuestionPost
    ).subscribe((saveData: any) => {
      this.MembersService.GetMemberQuestionnaire(
        this.route.snapshot.queryParamMap.get('id')
      ).subscribe((data) => {
        data = data.items;
        this.PersonalityEnneagramQuestion = data.filter(
          (questions: any) => questions.questionSubCategory === 'EnneagramTest'
        );
        let answeredQuestions = this.PersonalityTab.map((items: any) => {
          return items.answer;
        });
        this.PersonalityTab = data.filter(
          (questions: any) => questions.questionCategory === 'Personality'
        );
        let personalityQuestions = this.PersonalityTab.map((items: any) => {
          return items.answer;
        });
        this.PersonalityStressQuestion = data.filter(
          (questions: any) => questions.questionSubCategory === 'StressTest'
        );
        let answeredQuestionsStress = this.PersonalityTab.map((items: any) => {
          return items.answer;
        });
        this.PersonalityAnxietyQuestion = data.filter(
          (questions: any) => questions.questionSubCategory === 'AnxietyTest'
        );
        let answeredQuestionsAxiety = this.PersonalityTab.map((items: any) => {
          return items.answer;
        });

        this.notAnsweredQuestions = this.PersonalityEnneagramQuestion.filter(
          (question: any) => question.answer === 'not answered'
        ).map((question: any) => question.id);
        this.notAnsweredQuestionsStress = this.PersonalityStressQuestion.filter(
          (question: any) => question.answer === 'not answered'
        ).map((question: any) => question.id);
        this.notAnsweredQuestionsAnxiety =
          this.PersonalityAnxietyQuestion.filter(
            (question: any) => question.answer === 'not answered'
          ).map((question: any) => question.id);
        if (!answeredQuestions.includes(null)) {
          this.toast.successMessage('Personality answeres saved successfully');
          this.isSelectAnswered = false;
          this.savePersonalityBtn = false;
        } else if (!answeredQuestionsStress.includes(null)) {
          this.toast.successMessage('Personality answeres saved successfully');
          this.isSelectAnswered = false;
          this.savePersonalityBtn = false;
        } else if (!answeredQuestionsAxiety.includes(null)) {
          this.toast.successMessage('Personality answeres saved successfully');
          this.isSelectAnswered = false;
          this.savePersonalityBtn = false;
        } else if (personalityQuestions.includes(null)) {
          this.toast.successMessage('Personality answeres saved successfully');
          // this.toastr.warning("Some questions are not answered");
          this.savePersonalityBtn = false;
        } else {
          this.toast.successMessage('Personality answeres saved successfully');
        }
      });
    });
  }
  postCheckboxValues() {
    const selectedConditions: any = {};
    for (const condition of Object.keys(
      this.familyHistoryData.familyHistoryData.conditions
    )) {
      selectedConditions[condition] = {
        'Grand Parents':
          this.familyHistoryData.familyHistoryData.conditions[condition][
            'Grand Parents'
          ],
        Mother:
          this.familyHistoryData.familyHistoryData.conditions[condition][
            'Mother'
          ],
        Father:
          this.familyHistoryData.familyHistoryData.conditions[condition][
            'Father'
          ],
        Siblings:
          this.familyHistoryData.familyHistoryData.conditions[condition][
            'Siblings'
          ],
      };
    }
  }
  subSelectedTab(type: any, tab: any) {
    this.getMemberQuetions();
    this.subTab = tab;
    if (tab === 'NeoTranscript') {
      this.loadMemberTranscriptDetails();
    }
    if (tab === 'NewOnboarding') {
      this.loadOnboardingQuestions();
      this.loadMemberPlanStatus();
    }
  }

  /** Same id as GetMemberById — full 24-char ObjectId string. */
  private getTranscriptMemberId(): string {
    return (
      this.member?.memberId ??
      this.route.snapshot.queryParamMap.get('id') ??
      this.route.snapshot.paramMap.get('memberId') ??
      this.memberId ??
      ''
    );
  }

  private resolveMemberForTranscript(): void {
    const routeMemberId =
      this.route.snapshot.queryParamMap.get('id') ||
      this.route.snapshot.paramMap.get('memberId') ||
      '';
    if (!routeMemberId) {
      return;
    }
    this.MembersService.getMemberById(routeMemberId).subscribe({
      next: (data) => {
        this.member = data?.result ?? null;
        this.loadMemberTranscriptDetails();
      },
      error: () => {
        this.loadMemberTranscriptDetails();
      },
    });
  }

  loadMemberTranscriptDetails(): void {
    const memberId = this.getTranscriptMemberId();
    if (!memberId) {
      this.neoTranscriptError = 'No member selected.';
      this.memberTranscript = null;
      return;
    }
    this.neoTranscriptLoading = true;
    this.neoTranscriptError = null;
    this.memberTranscriptApiService.getMemberTranscript(memberId).subscribe({
      next: (res) => {
        this.memberTranscript = res;
        this.memberTranscriptEnabled = !!res.isEnabled;
        this.neoTranscriptLoading = false;
        //console.log('Member timezone:', res.timeZone);
        // this.tryAutoFill();
      },
      error: (err) => {
        this.memberTranscript = null;
        this.neoTranscriptError = this.getApiErrorMessage(
          err,
          'Could not load member transcript.'
        );
        this.neoTranscriptLoading = false;
      },
    });
  }

  onTranscriptStatusToggle(isEnabled: boolean): void {
    const memberId = this.getTranscriptMemberId();
    if (!memberId) {
      this.toast.errorMessage('No member selected.');
      return;
    }
    this.statusUpdateLoading = true;
    this.neoTranscriptError = null;
    this.memberTranscriptApiService
      .updateMemberStatus(memberId, isEnabled)
      .subscribe({
        next: (res) => {
          this.toast.successMessage(res.message || 'Status updated successfully');
          this.loadMemberTranscriptDetails();
          this.statusUpdateLoading = false;
        },
        error: (err) => {
          this.memberTranscriptEnabled = !isEnabled;
          const message = this.getApiErrorMessage(
            err,
            'Failed to update transcript status.'
          );
          this.neoTranscriptError = message;
          this.toast.errorMessage(message);
          this.statusUpdateLoading = false;
        },
      });
  }

  archiveMemberTranscript(): void {
    const memberId = this.getTranscriptMemberId();
    if (!memberId || this.archiveLoading) return;
    this.archiveLoading = true;
    this.neoTranscriptError = null;
    this.memberTranscriptApiService.archiveMember(memberId).subscribe({
      next: (res) => {
        this.toast.successMessage(res.message || 'Transcript archived successfully');
        this.loadMemberTranscriptDetails();
        this.archiveLoading = false;
      },
      error: (err) => {
        const message = this.getApiErrorMessage(err, 'Failed to archive member.');
        this.neoTranscriptError = message;
        this.toast.errorMessage(message);
        this.archiveLoading = false;
      },
    });
  }

  unarchiveMemberTranscript(): void {
    const memberId = this.getTranscriptMemberId();
    if (!memberId || this.archiveLoading) return;
    this.archiveLoading = true;
    this.neoTranscriptError = null;
    this.memberTranscriptApiService.unarchiveMember(memberId).subscribe({
      next: (res) => {
        this.toast.successMessage(res.message || 'Member unarchived successfully');
        this.loadMemberTranscriptDetails();
        this.archiveLoading = false;
      },
      error: (err) => {
        const message = this.getApiErrorMessage(err, 'Failed to unarchive member.');
        this.neoTranscriptError = message;
        this.toast.errorMessage(message);
        this.archiveLoading = false;
      },
    });
  }

  private tryAutoFill(): void {
    if (this.autofillDone) return;
    if (!this.memberTranscript?.neoConversations?.length) return;
    if (!this.PersonalityTab?.length) return;
    this.autofillDone = true;
    this.autoFillFromTranscript();
  }

  /** ICU reports ambiguous/generic offsets (e.g. "GMT+5:30") for these zones instead of the common abbreviation. */
  private static readonly ZONE_ABBREVIATIONS: Record<string, string> = {
    'Asia/Kolkata': 'IST',
    'Asia/Calcutta': 'IST',
  };

  /** Member's registered IANA timezone (e.g. "Asia/Kolkata"), resolved server-side from the members collection. */
  private getMemberTimeZone(): string {
    return this.memberTranscript?.timeZone?.trim() || 'UTC';
  }

  /** Formats a NeoConversation unix timestamp in the member's own timezone, e.g. "29 Sep 2025, 02:53 PM IST". */
  formatConversationTimestamp(timestamp?: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp * 1000);
    const timeZone = this.getMemberTimeZone();
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).formatToParts(date);
    const get = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
    const zoneLabel =
      MemberQuetionsComponent.ZONE_ABBREVIATIONS[timeZone] ??
      new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'short' })
        .formatToParts(date)
        .find((p) => p.type === 'timeZoneName')?.value ??
      '';
    return `${get('day')} ${get('month')} ${get('year')}, ${get('hour')}:${get('minute')} ${get('dayPeriod')} ${zoneLabel}`;
  }

  private flattenTranscript(): string {
    const convs = this.memberTranscript?.neoConversations ?? [];
    return convs.map((conv: any, i: number) => {
      const date = this.formatConversationTimestamp(conv.timestamp);
      const lines = (conv.transcript ?? [])
        .map((e: any) => `${e.role === 'agent' ? 'Renee' : 'Member'}: ${e.message ?? ''}`)
        .join('\n');
      return `--- Session ${i + 1}${date ? ` (${date})` : ''} ---\n${lines}`;
    }).join('\n\n');
  }

  private collectAllQuestions(): any[] {
    const tabs: any[] = [
      ...(this.PersonalityTab ?? []),
      ...(this.LifestyleTab ?? []),
      ...(this.LifestyleTabTextQuestions ?? []),
      ...(this.LifestyleTabDropDownQuestions ?? []),
      ...(this.HealthAndMedicationTab ?? []),
      ...(this.FitnessTab ?? []),
      ...(this.DietaryRadioQuestion ?? []),
      ...(this.DietaryDropDownQuestions ?? []),
      ...(this.DietaryTab ?? []),
    ];
    const seen = new Set<string>();
    return tabs.filter((q: any) => {
      if (!q?.id || seen.has(q.id)) return false;
      seen.add(q.id);
      return true;
    }).map((q: any) => ({
      id: q.id,
      category: q.questionCategory ?? '',
      subCategory: q.questionSubCategory ?? '',
      question: q.question ?? '',
      dataType: q.dataType ?? 'radio',
      options: Array.isArray(q.options)
        ? q.options.map((o: any) => typeof o === 'string' ? o : (o.key ?? o.val ?? o.text ?? o.label ?? String(o)))
        : [],
    }));
  }

  autoFillFromTranscript(): void {
    const questions = this.collectAllQuestions();
    if (!questions.length) return;

    const transcript = this.flattenTranscript();
    const memberId = this.getTranscriptMemberId();
    if (!memberId || !transcript.trim()) return;

    this.autofillLoading = true;
    this.memberTranscriptApiService.autofillFromTranscript(memberId, transcript, questions).subscribe({
      next: (res: any) => {
        this.autofillLoading = false;
        if (!res?.success || !res.answers?.length) return;

        const allTabs: any[] = [
          ...(this.PersonalityTab ?? []),
          ...(this.LifestyleTab ?? []),
          ...(this.LifestyleTabTextQuestions ?? []),
          ...(this.LifestyleTabDropDownQuestions ?? []),
          ...(this.HealthAndMedicationTab ?? []),
          ...(this.FitnessTab ?? []),
          ...(this.DietaryRadioQuestion ?? []),
          ...(this.DietaryDropDownQuestions ?? []),
          ...(this.DietaryTab ?? []),
        ];

        res.answers.forEach((item: any) => {
          const { questionId, answer } = item;
          if (!questionId || answer === undefined || answer === null) return;

          const q = allTabs.find((x: any) => x?.id === questionId);
          const category = q?.questionCategory ?? '';
          const subCategory = q?.questionSubCategory ?? '';

          // For dropdown questions ({val, key} options), the LLM returns the
          // display text (key). Resolve it back to the stored value (val).
          let resolvedAnswer = answer;
          if (q && Array.isArray(q.options) && q.options.length > 0 && typeof q.options[0] === 'object') {
            const match = q.options.find((o: any) => o.key === answer || o.val === answer);
            if (match?.val !== undefined) resolvedAnswer = match.val;
          }

          // Personality / Lifestyle radio → selectedOptions (isSelected checks here)
          if (category !== 'Dietary') {
            this.selectedOptions[questionId] = resolvedAnswer;
          }

          // Dietary radio → selectedOptionsForDietary (isSelectedDietary checks here)
          if (category === 'Dietary' && subCategory !== 'plainText') {
            this.selectedOptionsForDietary[questionId] = resolvedAnswer;
          }

          // Update question.answer for text/time/dropdown [value] bindings
          if (q) q.answer = resolvedAnswer;

          const postEntry = {
            questionId,
            memberId: this.memberId,
            answer: resolvedAnswer,
            loggedInUserId: this.memberId,
          };
          if (category === 'Personality') {
            this.PersonalityQuestionPost.push(postEntry);
            this.isSelectedAnswerBool = true;
          } else if (category === 'Lifestyle') {
            this.LifestyleQuestionDataPost.push(postEntry);
          } else if (category === 'Fitness') {
            this.FitnessQuestionDataPost.push(postEntry);
          } else if (category === 'Dietary') {
            this.DietaryQuestionPost.push(postEntry);
            this.isSelectedDietaryAnswerBool = true;
          }
        });
      },
      error: () => {
        this.autofillLoading = false;
      },
    });
  }

  private getApiErrorMessage(err: any, fallback: string): string {
    const status = err?.status;
    if (status === 404) {
      return 'Member not found';
    }
    return err?.error?.message ?? err?.message ?? fallback;
  }
  formatConversionHandler(inputTime: string): string {
    const date = new Date('2000-01-01 ' + inputTime);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  //upload Lab Work
  onReportSelected(event: any) {
    const fileInput = event.target;
    this.isPrescriptionUploadDisabled = true;
    this.fileType = 'report';
    if (fileInput.files.length > 0) {
      this.selectedFileName = fileInput.files[0].name;
      this.selectedFile = fileInput.files[0];
    } else {
      this.selectedFileName = '';
    }

    console.log(this.selectedFileName);
  }

  onPrescriptionSelected(event: any) {
    this.selectedPrescriptionName = '';
    const fileInput = event.target;
    this.isReportUploadDisabled = true;
    this.fileType = 'prescription';
    if (fileInput.files.length > 0) {
      this.selectedPrescriptionName = fileInput.files[0].name;
      this.selectedFile = fileInput.files[0];
    } else {
      this.selectedFile = fileInput.files[0];
    }
  }
}
